var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RequisitionPDFFooter"},[_c('span',{staticClass:"Pages"},[_vm._v(_vm._s(_vm.mixWB('PAGE_X_OF_Y', [_vm.currentPage, _vm.totalPages])))])])}
var staticRenderFns = []

export { render, staticRenderFns }